import { render, staticRenderFns } from "./PayView.vue?vue&type=template&id=4d2c083e&scoped=true&"
import script from "./PayView.vue?vue&type=script&lang=js&"
export * from "./PayView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2c083e",
  null
  
)

export default component.exports